import ptBR from './pt-BR';
import enUS from './en-US';

const getLocale = () => {
  var lang = localStorage.getItem("lang");
  var locale = ptBR;
  switch(lang) {
    case 'pt-BR':
      locale = ptBR;
      break;
    case 'en-US':
      locale = enUS;
      break;
    default:
      locale = ptBR;
      break;
  }

  return locale();

};

export default getLocale;


// WEBPACK FOOTER //
// ./src/i18n/getLocale.jsx